
import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Footer component – displays site information, navigation links,
 * and legal notices.
 *
 * The component is exported as the default export once.
 * All class names are Tailwind‑CSS utilities.
 */
export default function Footer() {
  const navigate = useNavigate();

  const handleLegalClick = (section?: string) => {
    if (section) {
      navigate(`/rechtliches#${section}`);
    } else {
      navigate('/rechtliches');
    }
  };

  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Beschreibung */}
          <div className="md:col-span-1">
            <p className="text-gray-300 mb-6 max-w-md">
              Ihr Online-Shop für hochwertige Snacks und Getränke. <br />
              Frische Produkte, schnelle Lieferung und erstklassiger Service.
            </p>
          </div>

          {/* Kundenservice */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Kundenservice</h4>
            <div className="space-y-3">
              <button
                onClick={() => handleLegalClick('kontakt')}
                className="block text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                Kontakt
              </button>
              <button
                onClick={() => handleLegalClick('faq')}
                className="block text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                FAQ
              </button>
              <button
                onClick={() => handleLegalClick('versand')}
                className="block text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                Versand & Rückgabe
              </button>
            </div>
          </div>

          {/* Rechtliches */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Rechtliches</h4>
            <div className="space-y-3">
              <button
                onClick={() => handleLegalClick('impressum')}
                className="block text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                Impressum
              </button>
              <button
                onClick={() => handleLegalClick('datenschutz')}
                className="block text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                Datenschutz
              </button>
              <button
                onClick={() => handleLegalClick('agb')}
                className="block text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                AGB
              </button>
              <button
                onClick={() => handleLegalClick('widerrufsrecht')}
                className="block text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
              >
                Widerrufsrecht
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-400 text-sm">
            © 2024 Dä Snäckomat. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <div className="flex items-center space-x-2">
              <span className="text-gray-400 text-sm">Zahlungsmethoden:</span>
              <div className="flex space-x-2">
                <i className="ri-bank-card-line text-2xl text-gray-400"></i>
                <span className="text-gray-400 text-sm">TWINT</span>
              </div>
            </div>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
